var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRIconDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "R_Icon_Dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-\\u2013-Iconography",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R_Icon_Dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container",
    opacity: 0,
    fill: "#DDDDDD"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Circle",
    transform: "translate(1, 1)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8344093,13.7168596 C17.7881873,12.1812138 18,10.8913216 18,9.14285714 C18,4.09339657 13.9705627,0 9,0 C4.02943725,0 0,4.09339657 0,9.14285714 C0,10.8086333 0.438518268,12.3703622 1.20467918,13.7154084",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.625,
    y1: 15.4285714,
    x2: 12.375,
    y2: 15.4285714,
    id: "Line"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIconDashboard);
export default __webpack_public_path__ + "static/media/R_Icon_Dashboard.2274be20278d440d99561ba14cfb6eb0.svg";
export { ForwardRef as ReactComponent };